import React from 'react'
import {
  SanityBasicImage,
  SanityChecklistBox,
  SanityPageIntro,
} from '../../types/generated/graphql-types'
import { PageIntroProps } from '../components/blocks/PageIntro'
import { DonutGraphCard } from '../components/Graphs/DonutGraphCard'
import { Image } from '../components/Image'
import {
  PageIntroChecklist,
  PageIntroChecklistProps,
} from '../components/PageIntroChecklist'
import { Breakpoints } from '../utilities/breakpoints'
import { notEmpty, validImage } from '../utilities/filters'
import { Presets } from '../utilities/imagePreset'
import { getImagePropsWithSources } from '../utilities/imagePropUtils'
import { mapSanityDonutGraphCardToDonutGraphCardProps } from './GraphCardMapper'

const mapSanityChecklistBoxToPageIntroChecklistProps = ({
  bullets,
  complementaryText,
  title,
}: SanityChecklistBox): PageIntroChecklistProps => ({
  bullets: bullets?.filter(notEmpty) ?? [],
  complementaryText: complementaryText ?? undefined,
  title: title ?? undefined,
})

export const mapSanityPageIntroToPageIntroProps = ({
  _rawBody,
  block,
  preamble,
  title,
}: SanityPageIntro): PageIntroProps => {
  let rightColumnContent: JSX.Element | undefined
  let rightColumnHiddenOnSmallScreens = false

  const rightBlock = block?.[0]

  switch (rightBlock?._type) {
    case 'checklistBox':
      rightColumnContent = (
        <PageIntroChecklist
          {...mapSanityChecklistBoxToPageIntroChecklistProps(rightBlock)}
        />
      )
      break
    case 'donutGraphCard':
      rightColumnContent = (
        <DonutGraphCard {...mapSanityDonutGraphCardToDonutGraphCardProps(rightBlock)} />
      )
      break
    case 'basicImage':
      const image = rightBlock as SanityBasicImage | undefined

      rightColumnHiddenOnSmallScreens = true

      rightColumnContent = validImage(image) ? (
        <Image
          {...getImagePropsWithSources(
            image,
            {
              small: Presets.pageIntroImage.small,
              medium: Presets.pageIntroImage.medium,
            },
            Breakpoints.lg
          )}
          imgClassName="rounded-15"
        />
      ) : undefined
      break
  }

  return {
    body: _rawBody ?? undefined,
    preamble: preamble ?? undefined,
    rightColumnContent,
    rightColumnHiddenOnSmallScreens,
    title: title ?? undefined,
  }
}
